// ** Third Party Components
import styled from "styled-components";

// ####################################################

export const StyledAttachmentPreview = styled("img")`
	display: block;
	width: 100%;
	background-color: ${({ theme: { isDarkMode } }) =>
		isDarkMode ? "#424242" : "#d0d0d0"};
`;

// ####################################################
